import { render, staticRenderFns } from "./ProductPlaceholder.vue?vue&type=template&id=20649dd6"
import script from "./ProductPlaceholder.vue?vue&type=script&lang=js"
export * from "./ProductPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports